import { createFunctionLibrary } from '../functionLibrary'
import { BeckyRequestPayload, SiteAssetsModule } from '../types/becky'
import { flattenStructure } from '../flattenStructure'
import {
	getBeckyTopology,
	getRequestedPageCompId,
	resolveBeckyModel,
} from '../siteAssetsModules/helpers/resolveBeckyModel'
import { Component, DeepStructure, Structure } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'
import { resolveByRefComponents } from './resolveByRefComponents'

export const resolveByRef = resolveByRefComponents
export const buildDeepStructure = (comp: Component, flatStructure: Structure): DeepStructure => {
	// @ts-ignore
	const children = comp.children || comp.components
	if (!_.isEmpty(children)) {
		const components = _.map(children, (child) => buildDeepStructure(flatStructure[child], flatStructure))
		// @ts-ignore
		return _(comp)
			.omit(['components', 'parent'])
			.defaults({ [comp.id === 'masterPage' ? 'children' : 'components']: components })
			.value()
	}
	// @ts-ignore
	return _.omit(_.clone(comp), 'parent')
}

const byRefModule: SiteAssetsModule<BeckyRequestPayload> = (moduleContext) => {
	const { httpClient, metricsReporter, topology } = moduleContext

	const functionLibrary = createFunctionLibrary({
		httpClient,
		metricsReporter,
	})

	return {
		execute: async (payload) => {
			const beckyTopology = getBeckyTopology(topology, payload)
			const beckyModel = await resolveBeckyModel({ payload, topology: beckyTopology })
			const masterPage = await payload.pages.masterPage
			const masterPageStructure = flattenStructure(masterPage.structure, payload.viewMode === 'mobile')
			const masterPageData = masterPage.data
			const { structure, data } = await resolveByRefComponents(
				beckyModel,
				masterPageStructure,
				masterPageData,
				functionLibrary,
				topology,
				payload
			)

			const requestedPageCompId = getRequestedPageCompId(payload.pages)
			const currentPage = await payload.pages[requestedPageCompId]
			currentPage.data = data
			currentPage.structure = buildDeepStructure(structure[requestedPageCompId], structure)
			payload.pages[requestedPageCompId] = Promise.resolve(currentPage)

			return payload
		},
	}
}

export default byRefModule
